module.exports = __webpack_public_path__ + "media/mypage/images/special/new_working-cd4cddf0969dd89b3a971ff26a52929b.jpg";